import React from 'react';

import { AppStore } from '../App/stores/AppStore.js';
import { useStores } from '../hooks/useStores.js';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
	const appStore = useStores<AppStore>('appStore');
	const { isSnapshot, appLevelGuid } = appStore;

	return (
		<div
			role="tabpanel"
			className="tab-panel"
			hidden={value !== index}
			id={`${appLevelGuid}-tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
		>
			{(isSnapshot || value === index) && children}
		</div>
	);
};

export default TabPanel;
